import styled, { css } from "styled-components";

import colors from "../../../themes/colors";

interface TableProps {
  readonly isRowClickable?: boolean;
  readonly showOuterBorder?: boolean;
  readonly compact?: boolean;
}

export const Styles = styled.div<TableProps>`
  padding: ${(props) => (props.compact ? "0" : "1rem 0")};
  overflow-x: auto;
  max-width: 100%;

  table {
    width: 100%;
    table-layout: fixed;
    margin-bottom: 0;
    border-spacing: 0;
    border: ${(props) =>
      props.showOuterBorder === false
        ? "1px solid transparent"
        : "1px solid black"};

    th {
      border-top: 1px solid black;
    }

    tr {
      &.grouped-row {
        background-color: ${colors.veryLightOpacityGrey};
      }

      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-top: 0;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }

    ${(props) =>
      props.isRowClickable &&
      css`
        tbody {
          cursor: pointer;
          tr[role="row"] {
            :hover {
              background-color: ${colors.lightGreyishBlue};
            }
          }
        }
      `}
  }
`;

export const PaginationText = styled.span`
  padding-left: 10px;
  padding-right: 10px;
`;
